import { useEffect, useState } from 'react';

const useOnline = () => {
  const [online, setOnline] = useState(true);

  useEffect(
    () => {
      window.addEventListener('online', handleConnectionChange);
      window.addEventListener('offline', handleConnectionChange);
      return () => {
        window.removeEventListener('online', handleConnectionChange);
        window.removeEventListener('offline', handleConnectionChange);
      };
    },
    []
  );

  const handleConnectionChange = () => {
    setOnline(navigator.onLine);
  };

  return online;
};

export default useOnline;